// Step ids share the cross-market `lastStepID` vocabulary ("pets" | "coverage" | "billing") that the
// US form established and downstream consumers (resume links, retargeting, analytics) rely on — so the
// final step's id is "billing" even though its label is "Checkout" (mirrors UsQuoteFormSteps.BILLING).
export type CaQuoteFormStepIds = "pets" | "coverage" | "billing";

export const CaQuoteFormSteps = {
    PETS: { id: "pets", order: 1, label: "Pet Info" },
    COVERAGE: { id: "coverage", order: 2, label: "Plan" },
    BILLING: { id: "billing", order: 3, label: "Checkout" }
} satisfies Record<string, { id: CaQuoteFormStepIds; order: number; label: string }>;
